// src/app/app.component.ts
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule, Routes } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';
import { DonateBannerComponent } from './components/donate-banner/donate-banner.component';
import { HomeComponent } from './pages/home/home.component';
import { IssueDetailComponent } from './issue-detail/issue-detail.component';
import { MetaPixelService } from './services/meta-pixel.service';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'issue/:id', component: IssueDetailComponent }
];

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    FooterComponent,
    CookieBannerComponent,
    DonateBannerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'lydialynnchristensen';

  constructor(
    private router: Router,
    private metaPixel: MetaPixelService
  ) {}

  ngOnInit(): void {
    this.metaPixel.initialize();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.metaPixel.trackPageView();
    });

    this.printEasterEgg();
  }

  private printEasterEgg(): void {
    const styles = {
      title:   'color: #61934E; font-size: 20px; font-weight: bold;',
      green:   'color: #004320; font-size: 13px; font-weight: bold;',
      white:   'color: #ffffff; background: #004320; font-size: 13px; padding: 2px 6px;',
      body:    'color: #374151; font-size: 12px;',
      orange:  'color: #f7931a; font-size: 12px; font-weight: bold;',
      small:   'color: #9ca3af; font-size: 11px;',
    };

    console.log('%c★ UNCHAIN MICHIGAN ★', styles.title);
    console.log('%cLydia Christensen for U.S. Senate — Michigan 2026', styles.green);
    console.log(' ');
    console.log('%c Hey, developer. %c You found the easter egg.', styles.white, styles.body);
    console.log(' ');
    console.log('%c This site was built by the candidate herself.', styles.body);
    console.log('%c Angular • TypeScript • EmailJS • Donorbox', styles.orange);
    console.log('%c No consultants. No agency. Just a programmer running for Senate.', styles.body);
    console.log(' ');
    console.log('%c But if you believe in digital rights, net neutrality,', styles.body);
    console.log('%c and putting a technologist in the Senate — we\'d love your help.', styles.body);
    console.log(' ');
    console.log('%c Volunteer: lydialynnchristensen.com/#/volunteer', styles.orange);
    console.log('%c Email:     senator@lydialynnchristensen.com', styles.orange);
    console.log('%c Discord:   discord.gg/DNqwMBsycY', styles.orange);
    console.log(' ');
    console.log('%c Paid for by Lydia Christensen for U.S. Senate • FEC ID: C00903575', styles.small);
  }
}
